<template lang="html">
  <div id="company-page">

    <section class="main-section">
      <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+imageUrl+')' }"></div>

      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-5 col-xl-6 col-image"></div>

          <div class="col-lg-6 col-text">
            <h1 class="mb-2 title-s1 c-primary">EXTRACTOS<strong>EUM</strong>™</h1>

            <h5 class="subtitle">PRODUCTORES, FABRICANTES Y DISTRIBUIDORES</h5>
            <p>
              Distribuidores mayoristas y a granel de CBD número uno de cannabinoides derivados del cáñamo cultivados en Estados Unidos
            </p>

            <h5 class="mt-4 subtitle">NUESTRA MISIÓN</h5>
            <p class="text-justify">
              En EXTRACTOS UNIDOS MEXICANOS (EXTRACTOS EUM) Somos expertos en formulaciones de cannabinoides personalizadas. Un equipo de formuladores, químicos y gerentes de cuentas que están altamente capacitados para saber qué formulaciones y potencias de cannabinoides se combinan mejor con qué sistema de administración. Pioneros en la industria y han construido la cadena de suministro de cannabinoides derivados del cáñamo más grande de EE. UU. ahora en México Tenemos la mayor selección de aislados, destilados, sabores, fórmulas y sistemas de entrega.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section-2">
      <div class="container oversized-container">
        <div class="row justify-content-center">
          <div class="col-lg-12 col-xl-9">
            <div class="box-info-1">
              <h5>Una empresa B2B centrada en el cliente que cree en proporcionar a nuestros clientes los mejores productos en el menor tiempo posible para productos mayoristas de CBD.</h5>
            </div>
          </div>
        </div>

        <div class="box-panels">
          <div class="col-lg-4 col-panel">
            <div class="box">
              <h5>La empresa líder en genética de cañamo de EE. UU. ahora en México.</h5>
            </div>
          </div>

          <div class="col-lg-4 col-panel">
            <div class="box">
              <h5>El principal extractor y proveedor de terpenos de cañamo de EE. UU.  ahora en México.</h5>
            </div>
          </div>

          <div class="col-lg-4 col-panel">
            <div class="box">
              <h5>Los mayores fabricantes de cGMP de productos terminados.</h5>
            </div>
          </div>

          <div class="col-lg-4 col-panel">
            <div class="box">
              <h5>Los laboratorios de extracción y purificación de CBD de cáñamo más eficientes y rentables de EE. UU. ahora en México.</h5>
            </div>
          </div>

          <div class="col-lg-4 col-panel">
            <div class="box">
              <h5>El Departamento de Agricultura más grande registró granjas de cáñamo en Oregon, Colorado, Nevada, California, Minnesota, Nueva York, Arizona y Carolina del Norte.</h5>
            </div>
          </div>

          <div class="col-lg-4 col-panel">
            <div class="box">
              <h5>Los mayores fabricantes de OTC de la FDALos laboratorios de certificación y pruebas de cañamo mejor calificadosProveedores de logística y envío directo sumamente efectivos.</h5>
            </div>
          </div>
        </div>
      </div>

      <div class="placed-backg box-banner" v-bind:style="{ backgroundImage: 'url('+imageUrlTwo+')' }"></div>

      <div class="container oversized-container">
        <div class="box-plans">
          <h2 class="mb-1 text-center title-2">NUESTRO PLAN</h2>

          <p class="p-md text-center">
            Nuestro plan mundial de cultivo de cáñamo ahora está activo y produce miles de kilogramos de aceite de CBD al por mayor fresco durante todo el año.
          </p>

          <div class="row row-plans">
            <div class="col-lg-6 col-plan">
              <h6 class="title">Como resultado</h6>
              <p>
                De nuestro arduo trabajo y dedicación para entregar a nuestros clientes la más alta calidad al por mayor de aceites basados en CBD, CBG, CBN, CBC de manera consistente, confiable y oportuna, hemos creado el cáñamo industrial más grande y eficiente del mundo cultivado en EE. UU. sistema de cadena de suministro.
              </p>
            </div>

            <div class="col-lg-6 col-plan">
              <h6 class="title">Así es como funciona...</h6>
              <p>
                Hemos aprovechado nuestra genética única de semillas de cáñamo feminizadas para proporcionar a nuestros cultivadores de cáñamo cepas con alto contenido de CBD, CBG, CBN, CBC y otros compuestos de cañamo sinérgicos de origen natural raros y únicos con menos del 0,3% de THC.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-3">
      <div class="container oversized-container">
        <div class="row justify-content-center">
          <div class="col-lg-9">
            <h2 class="mb-1 text-center title-2">NOSOTROS</h2>

            <p>
              Proporcionamos a nuestros cultivadores de cáñamo las semillas feminizadas y los clones de estas genéticas patentadas para que se les asegure las mayores tasas de éxito de germinación y propagación posibles.<br />
              <br />
              Antes y después de cada cosecha, nuestros agricultores prueban el material vegetal para garantizar la ausencia de pesticidas, metales pesados, mohos o hongos.

              Una vez que se completan las pruebas, nuestros productores de cáñamo industrial registrados procesan y envían la biomasa de cáñamo rica en fitocannabinoides a una de nuestras instalaciones de extracción autorizadas ubicadas en todo el país para convertirla en aceite de CBD de espectro completo, aceite de cáñamo de amplio espectro libre de THC o aislado de CBD. Aislado de CBG, aislado de CBN o aislado de CBC.<br />
              <br />
              Una vez convertido en aceite o aislado rico en cannabinoides, a cada lote se le asigna un código de barras único y se certifica en dos de nuestros laboratorios de prueba de terceros certificados y con licencia estatal, así como también se prueba internamente en nuestras máquinas de prueba analíticas HPLC o GCMS antes. siendo aprobado por nuestro equipo de control de calidad cGMP y colocado en nuestro sistema de gestión de inventario. Una vez en inventario, nuestro aceite de CBD, aceite de CBG, aceite de CBN y aceites de CBC están listos para ser formulados, distribuidos directamente a nuestros distribuidores de CBD a granel y mayoristas de CBD, o enviados a nuestros socios de fabricación GMP / ISO / OTC de clase mundial. para convertirse en polvos, líquidos o productos terminados de CBD de marca blanca con nano-CBD solubles en agua.<br />
              Una vez completada la fabricación de GMP en productos terminados de CBD o nano ingredientes solubles en agua, nuestros socios de fabricación están obligados por los estándares de fabricación de GMP a enviar una muestra a un laboratorio externo para verificar que el producto se dosificó con precisión y cumpliera con las normas.<br />
              <br />
              Una vez que se confirman estos resultados, los productos se nos devuelven para que podamos inventariarlos y distribuirlos o distribuirlos directamente a nuestros clientes.<br />
              <br />
              Cada vez que se reciben productos de CBD terminados de la fabricación, nuevamente enviamos el producto a dos laboratorios independientes de terceros con licencia estatal para garantizar la potencia, pureza y dosificación precisas. Una vez que se completan las pruebas de laboratorio, se asigna un código QR al producto que vincula los resultados del laboratorio de terceros al sitio web del cliente junto con otros documentos de trazabilidad desde la semilla hasta la venta.<br />
              <br />
              A partir de ahí, los productos de CBD Wholesale se distribuyen directamente a nuestros clientes ubicados en todo el mundo o se envían directamente a sus clientes a través de nuestro programa de envío directo de CBD directo al consumidor.
            </p>
          </div>
        </div>
      </div>
    </section>

    <GuaranteeComponent></GuaranteeComponent>
  </div>
</template>

<script>
import GuaranteeComponent from './guarantee-component.vue';

export default {
  components: {
    GuaranteeComponent
  },
  data(){
    return{
      imageUrl: null,
      imageUrlTwo:null,
      
    }
  },
  methods: {
    getRows: function(){

      axios.get(tools.url('/api/imagescompany')).then((response)=>{
          this.imageUrl = response.data.imageUrl;
          this.imageUrlTwo = response.data.imageUrlTwo;
      });
    }
  },

  mounted(){
     this.getRows();
  },
}
</script>





